// removed by extract-text-webpack-plugin
module.exports = {"root":"index-root-1qA7i","text":"index-text-2l6YA"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/not-found/index.less
// module id = 739
// module chunks = 0